import { useCallback, useState } from 'react';

export default function useBreadcrumbModel() {
  const [pageTitle, setPageTitleState] = useState<string | undefined>(
    undefined,
  );

  const setPageTitle = useCallback((t?: string) => {
    setPageTitleState(t);
  }, []);

  return { pageTitle, setPageTitle };
}
